import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=716cd694&scoped=true&"
import script from "./SignUpPage.vue?vue&type=script&lang=js&"
export * from "./SignUpPage.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=716cd694&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716cd694",
  null
  
)

export default component.exports